import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/agents/prompts")({
  component: () => (
    <PlaceholderPanel
      title="Prompt Version Control"
      description="Git-like interface: version history, side-by-side diff, rollback, approval workflow, template library"
    />
  ),
})
